"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const utilities_1 = require("../utilities");
const Button_1 = tslib_1.__importDefault(require("../Button"));
const Dimmer_1 = tslib_1.__importDefault(require("./Dimmer"));
const Popup_1 = tslib_1.__importDefault(require("./Popup"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const uniqueId = require('lodash.uniqueid');
const Popups = styled_components_1.default.div ``;
class PopupProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            popups: {},
        };
        this.getChildContext = () => {
            return {
                confirm: (text) => {
                    return new Promise((resolve, reject) => {
                        const uid = uniqueId();
                        const popups = Object.assign({}, this.state.popups);
                        popups[uid] = {
                            type: 'CONFIRM',
                            payload: {
                                text,
                                buttons: [
                                    React.createElement(Button_1.default, { primary: true, basic: true, onClick: () => {
                                            reject();
                                            this.close(uid);
                                        } }, (0, utilities_1.__)('Zrušiť')),
                                    React.createElement(Button_1.default, { primary: true, onClick: () => {
                                            resolve();
                                            this.close(uid);
                                        } }, (0, utilities_1.__)('OK')),
                                ],
                            },
                        };
                        this.setState({
                            popups,
                        });
                    });
                },
                alert: (text) => {
                    return new Promise(resolve => {
                        const uid = uniqueId();
                        const popups = Object.assign({}, this.state.popups);
                        popups[uid] = {
                            type: 'ALERT',
                            payload: {
                                text,
                                buttons: [
                                    React.createElement(Button_1.default, { primary: true, onClick: () => {
                                            resolve();
                                            this.close(uid);
                                        } }, (0, utilities_1.__)('OK')),
                                ],
                            },
                        };
                        this.setState({
                            popups,
                        });
                    });
                },
            };
        };
        this.close = (uid) => {
            const popups = Object.assign({}, this.state.popups);
            delete popups[uid];
            this.setState({
                popups,
            });
        };
        this.renderPopup = (popupUid, idx) => {
            const popup = this.state.popups[popupUid];
            return (React.createElement(Popup_1.default, { key: idx, order: idx, text: popup.payload.text, buttons: popup.payload.buttons }));
        };
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.props.children,
            Object.keys(this.state.popups).length > 0 && React.createElement(Dimmer_1.default, null),
            React.createElement(Popups, null, Object.keys(this.state.popups).map(this.renderPopup))));
    }
}
exports.default = PopupProvider;
